import { takeLatest, put, all, call } from "redux-saga/effects";

import loginActionTypes from "./login.types";
import {
  userSignIn,
  authUserVerification,
  forgotPasswordUpdate,
  updateUserPasswordCall,
  userCompanyLoginDetailsGet,
} from "./login.services";
import {
  userSignInSuccess,
  userSignInFailure,
  userSignInResponseChanged,
  userSignInLogOut,
  userAuthVerifySuccess,
  userAuthVerifyFailure,
  userAuthVerifyResponseChanged,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  forgotPasswordResponseChanged,
  updateUserPasswordSuccess,
  updateUserPasswordFailure,
  updateUserPasswordResponseChanged,
  fetchUserCompanyDetailsSuccess,
  fetchUserCompanyDetailsFailure,
  fetchUserCompanyDetailsResponseChanged,
  userTotpRequired,
} from "./login.action";
import { encryptData } from "../_common/enode-decode";
/** ********** USER LOGIN CHECK SATRT **************** */
// type AnyAction = { type: JSON; [key: string]: any };
export function* singInWithPhoneNumber({ payload }: any) {
  try {
    const key = "UserLoginVerify";
    const { phoneNumber, password } = payload;

    const jsonData: any = {
      userName: phoneNumber,
      userPassword: password,
    };
    const loginData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userSignIn, loginData);
    if (responseData.data?.totpRequired) {
      // 2FA-enrolled staff: password OK, but hold the session until the
      // 6-digit Google-Authenticator code is verified (login step-2).
      yield put(userTotpRequired(responseData.data));
    } else if (responseData.data.statusCode === "100") {
      yield put(userSignInFailure(responseData.data));
    } else {
      yield put(userSignInSuccess(responseData.data));
    }
  } catch (error) {
    yield put(userSignInFailure(error));
  }
}

export function* makeUserLoginReset() {
  yield put(userSignInResponseChanged());
}

export function* onPhoneSignInReset() {
  yield takeLatest(
    loginActionTypes.USER_SIGN_IN_RESPONSE_RESET_START,
    makeUserLoginReset,
  );
}

export function* onUserSignInStart() {
  yield takeLatest(loginActionTypes.USER_SIGN_IN_START, singInWithPhoneNumber);
}
/** ********** USER LOGIN CHECK END **************** */

/** ********** USER LOGIN AUTH VERIFY CHECK SATRT **************** */
export function* verifyGoogleAuth({ payload }: any) {
  try {
    const { secrateAuth, authKeyNumber, loginUserID, staffID } = payload;
    const key = "LoginAuth";
    const jsonData: any = {
      secrateAuth,
      authKeyNumber,
      userID: loginUserID,
      staffID,
    };
    const authVerifyData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(authUserVerification, authVerifyData);
    if (responseData.data.statusCode === "100") {
      yield put(userAuthVerifyFailure(responseData.data));
    } else {
      yield put(userAuthVerifySuccess(responseData.data));
    }
  } catch (error) {
    yield put(userAuthVerifyFailure(error));
  }
}

export function* googleAuthVerifyReset() {
  yield put(userAuthVerifyResponseChanged());
}

export function* onAuthVerifyReset() {
  yield takeLatest(
    loginActionTypes.USER_AUTH_VERIFY_RESPONSE_RESET_START,
    googleAuthVerifyReset,
  );
}

export function* onAuthVerifyStart() {
  yield takeLatest(loginActionTypes.USER_AUTH_VERIFY_START, verifyGoogleAuth);
}
/** ********** USER LOGIN AUTH VERIFY CHECK END **************** */

/** *********LOGOUT *************** */
export function* makeUserSignInLogout() {
  yield put(userSignInLogOut());
}

export function* userSignInLogout() {
  yield takeLatest(loginActionTypes.USER_SIGN_OUT_START, makeUserSignInLogout);
}

/** *********************  START Forgot Password DETAILS  ******************** */
export function* forgotPasswordDetails({ payload }: any) {
  try {
    const key = "ForgotPassKey";
    const { MobileNumber } = payload;

    const jsonData: any = {
      UserName: MobileNumber,
    };
    const ForgotData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(forgotPasswordUpdate, ForgotData);
    if (responseData.data.statusCode === "100") {
      yield put(forgotPasswordFailure(responseData.data));
    } else {
      yield put(forgotPasswordSuccess(responseData.data));
    }
  } catch (error) {
    yield put(forgotPasswordFailure(error));
  }
}

export function* resetForgotPasswordResponse() {
  yield put(forgotPasswordResponseChanged());
}

export function* onForgotPasswordDetails() {
  yield takeLatest(
    loginActionTypes.FETCH_FORGOT_PASSWORD_START,
    forgotPasswordDetails,
  );
}

export function* onForgotPasswordDetailsResponseReset() {
  yield takeLatest(
    loginActionTypes.FETCH_FORGOT_PASSWORD_RESPONSE_RESET_START,
    resetForgotPasswordResponse,
  );
}
/** *********************  END ADD Forgotpassword DETAILS ******************** */

/** *********************  START USER PASSWORD DETAILS  ******************** */
export function* updateUserPasswordDetails({ payload }: any) {
  try {
    const key = "UPDATEUSERPASSWORDKEY";
    const {
      databaseName,
      companyID,
      userID,
      userName,
      UserPhoneNumber,
      confirmPassword,
    } = payload;
    const jsonData = {
      DatabaseName: databaseName,
      CompanyID: companyID,
      UserID: userID,
      UserName: userName,
      UserPhoneNumber: UserPhoneNumber,
      GeneralUserID: userID,
      ConfirmPassword: confirmPassword,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(updateUserPasswordCall, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateUserPasswordFailure(responseData.data));
    } else {
      yield put(updateUserPasswordSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateUserPasswordFailure(error));
  }
}

export function* resetUpdateUserPasswordResponse() {
  yield put(updateUserPasswordResponseChanged());
}

export function* onUpdateUserPassword() {
  yield takeLatest(
    loginActionTypes.UPDATE_USER_PASSWORD_START,
    updateUserPasswordDetails,
  );
}

export function* onUpdateUserPasswordResponseReset() {
  yield takeLatest(
    loginActionTypes.UPDATE_USER_PASSWORD_RESPONSE_RESET_START,
    resetUpdateUserPasswordResponse,
  );
}
/** *********************  END USER PASSWORD DETAILS ******************** */

/** *********************  START USER DETAILS LIST  ******************** */
export function* getUserCompanyDetails({ payload }: any) {
  try {
    const key = "GetUserCompanyDetailsKey";
    const jsonData = {
      DatabaseName: payload.databaseName,
      CompanyID: payload.companyID,
      UserID: payload.userID,
      RoleID: payload.roleID,
      RoleName: payload.roleName,
      PhoneNumber: payload.phonenumber,
      GeneralCompanyID: payload.generalCompanyID,
      GeneralAdminID: payload.generalAdminID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(userCompanyLoginDetailsGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchUserCompanyDetailsFailure(responseData.data));
    } else {
      yield put(fetchUserCompanyDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchUserCompanyDetailsFailure(error));
  }
}

export function* resetUserCompanyDetailsResponse() {
  yield put(fetchUserCompanyDetailsResponseChanged());
}

export function* onGetUserCompanyDetails() {
  yield takeLatest(
    loginActionTypes.FETCH_USER_COMPANY_DETAILS_START,
    getUserCompanyDetails,
  );
}

export function* onGetUserCompanyDetailsResponseReset() {
  yield takeLatest(
    loginActionTypes.FETCH_USER_COMPANY_DETAILS_RESPONSE_RESET_START,
    resetUserCompanyDetailsResponse,
  );
}

/** *********************  END USER DETAILS LIST  ******************** */

export function* loginSaga() {
  yield all([
    call(onUserSignInStart),
    call(userSignInLogout),
    call(onPhoneSignInReset),
    call(onAuthVerifyReset),
    call(onAuthVerifyStart),
    call(onForgotPasswordDetails),
    call(onForgotPasswordDetailsResponseReset),
    call(onUpdateUserPassword),
    call(onUpdateUserPasswordResponseReset),
    call(onGetUserCompanyDetails),
    call(onGetUserCompanyDetailsResponseReset),
  ]);
}
